/**
 * Como cada status das manutenções se lê e se pinta na tela.
 *
 * Papel: aqui ficam os rótulos dos dois status, letra por letra como a origem os
 * escreve, a ordem em que eles aparecem nos `select` e nas multiseleções, o tom
 * do selo de cada um e o percentual do andamento da corretiva
 * (`progressForStatus`, l. 806–811).
 *
 * Como usar: um valor novo em qualquer um dos dois enums do contrato precisa de
 * uma linha em cada mapa. Os mapas são `Record` do tipo do enum, para que
 * esquecer um deles vire erro de typecheck, e não um selo sem cor. A ordenação
 * por status compara o rótulo daqui, e não o valor do enum.
 */
import { type StatusCorretiva, type StatusPreventiva } from '@concierge/shared';

import { type PercentualDoAndamento } from './components/kit/barra-de-andamento';
import { type TomDoSelo } from './components/kit/selo';

/** O texto de cada status da corretiva. */
export const ROTULOS_STATUS_CORRETIVA: Readonly<Record<StatusCorretiva, string>> = {
  em_orcamento: 'Em Orçamento / Em Tratativa',
  agendado: 'Agendado / Em execução',
  concluido: 'Concluído',
};

/** A ordem das opções de status da corretiva (l. 531–533, 577–579, 650–655). */
export const ORDEM_DOS_STATUS_CORRETIVA: readonly StatusCorretiva[] = [
  'em_orcamento',
  'agendado',
  'concluido',
];

/** O tom do selo de cada status da corretiva. */
export const TOM_DO_SELO_CORRETIVA: Readonly<Record<StatusCorretiva, TomDoSelo>> = {
  em_orcamento: 'laranja',
  agendado: 'amarelo',
  concluido: 'verde',
};

/** O andamento de cada status da corretiva, que a barra do Dashboard mostra. */
export const PERCENTUAL_DO_ANDAMENTO: Readonly<
  Record<StatusCorretiva, PercentualDoAndamento>
> = {
  em_orcamento: 50,
  agendado: 75,
  concluido: 100,
};

/** O texto de cada status da preventiva. */
export const ROTULOS_STATUS_PREVENTIVA: Readonly<Record<StatusPreventiva, string>> = {
  em_dia: 'Em dia',
  em_andamento: 'Em andamento',
};

/** A ordem das opções de status da preventiva (l. 617–621, 682). */
export const ORDEM_DOS_STATUS_PREVENTIVA: readonly StatusPreventiva[] = [
  'em_dia',
  'em_andamento',
];

/** O tom do selo de cada status da preventiva. */
export const TOM_DO_SELO_PREVENTIVA: Readonly<Record<StatusPreventiva, TomDoSelo>> = {
  em_dia: 'verde',
  em_andamento: 'amarelo',
};
